import multiguard from 'vue-router-multiguard';
import { mapGetters } from 'vuex';
import router from '../router';
import { routerCheckFacilityUsageExists, routerCheckInitialStepComplete } from '../utils';

export default {
    name: 'DeleteActivityConfirmation',
    template: '#delete-activity-confirmation-template',
    beforeRouteEnter: multiguard([
        routerCheckInitialStepComplete,
        routerCheckFacilityUsageExists
    ]),
    props: ['index'],
    computed: {
        permitNumber() {
            return this.$store.state.permitNumber;
        },
        permitYear() {
            return this.$store.state.permitYear;
        },
        selectedFacilityUsage() {
            return this.$store.getters.getFacilityUsage(this.index);
        }
    },
    methods: {
        ...mapGetters([
            'indexOfFacilityUsage'
        ]),
        submitDeleteForm(event) {
            const idx = this.indexOfFacilityUsage({ index: this.index });
            this.$store.dispatch('removeFacilityUsage', idx);
            router.push(`/${this.permitNumber}/${this.permitYear}`);
        }
    }
};